import React from 'react'
import styles from './JobSeekerHeading.module.scss'

const JobSeekerHeading = ({ title, subHeading }) => {
  return (
    <>
      <div className="mt-5">
        <div className={styles.heading}>
          <h2>{title}</h2>
        </div>
        <div className={styles.arrow} />
      </div>
      <h3 className={`${styles.header} text-center my-4 `}>{subHeading}</h3>
    </>
  )
}

export default JobSeekerHeading
